import { useEffect } from "react";
import { useI18n } from "i18n";
import useCompany from "modules/company/hooks/useCompany";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import { useQuery } from "@tanstack/react-query";
import { useHistory } from "react-router";

const NAME = "create-company-if-it-doesn't-exist";

const useCreateCompany = () => {
  const { company, saveCompany, loadCompany } = useCompany();

  const { push } = useHistory();
  const { addErrorNotification } = useNotificationActions();
  const { t } = useI18n("common");

  const { isLoading, isError, error } = useQuery({
    queryKey: [NAME],
    queryFn: async () => {
      const response = await saveCompany({});

      if (!response?.isSuccess) {
        throw new Error("Company creation failed");
      }

      await loadCompany();
      return true;
    },
    enabled: !company,
    gcTime: Infinity,
  });

  useEffect(() => {
    if (!error) return;

    addErrorNotification({
      message: t("common:error.unknown"),
      position: "tc",
      autoDismiss: 10,
    });

    push("/my-events");
  }, [error, addErrorNotification, t, push]);

  return { isLoading, isError };
};

export default useCreateCompany;
